// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#select {
    display: flex;
    align-items: center;
}
.headset-icon{
    cursor: pointer;
    width: 20px;
    height: 20px;
    margin-right: 4px;
    margin-top: -2px;
    color: var(--color-primary);
    opacity: 0.9;
}`, "",{"version":3,"sources":["webpack://./src/layouts/SidebarLayout/Header/index.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,2BAA2B;IAC3B,YAAY;AAChB","sourcesContent":["#select {\n    display: flex;\n    align-items: center;\n}\n.headset-icon{\n    cursor: pointer;\n    width: 20px;\n    height: 20px;\n    margin-right: 4px;\n    margin-top: -2px;\n    color: var(--color-primary);\n    opacity: 0.9;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
